export default (imageFile) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.onload = e => resolve(e.target.result)
    reader.onerror = err => reject(err)

    reader.readAsDataURL(imageFile)
  })
}
